import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
	get_inspections,
	reset,
} from '../../features/inspection/inspectionSlice'
import Loader from '../../components/Preloader'
import Pagination from '../../components/Pagination'
import { useLocation } from 'react-router-dom'

function DashboardInspection() {
	const dispatch = useDispatch()
	const pageNumber = new URLSearchParams(useLocation().search).get('page') || 1

	const { loading, inspections } = useSelector((state) => state.allInspection)

	const categoryHead = [
		'S/N',
		'Property Name',
		'Name',
		'Contact',
		'Date',
		'Time',
	]
	let i = 0

	useEffect(() => {
		dispatch(get_inspections())

		return () => {
			dispatch(reset())
		}
	}, [dispatch])

	return (
		<section className='user_dashboard'>
			<div className='container'>
				{loading ? (
					<Loader />
				) : inspections &&
				  inspections.inspections &&
				  inspections.inspections.length > 0 ? (
					<>
						<div className='mt-5 table-responsive shadow-sm'>
							<table className='table table-bordered table-striped'>
								<thead className='' style={{ fontSize: '14px' }}>
									<tr>
										{categoryHead.map((cate, i) => (
											<th key={i}>{cate}</th>
										))}
									</tr>
								</thead>
								<tbody>
									{inspections.inspections.map((l, i) => (
										<tr key={l._id}>
											<td>{(inspections.meta.page - 1) * 10 + i + 1}</td>
											<td>{l.property}</td>
											<td> {l.name} </td>
											<td>
												{l.email} <br /> {l.phone}
											</td>
											<td> {l.date} </td>
											<td> {l.time} </td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
						{inspections.meta.pages > 1 && (
							<>
								<Pagination
									currentPage={Number(inspections.meta.page)}
									totalCount={Number(inspections.meta.total)}
									pageSize={10}
									pathname={`/admin/dashboard/inspection-entries`}
								/>
							</>
						)}
					</>
				) : (
					<div className='card mt-3'>
						<div className='card-body'>
							<p className='nothing'>No Inspection Entries found</p>
						</div>
					</div>
				)}
			</div>
		</section>
	)
}

export default DashboardInspection
